import debounce from 'lodash/debounce';

const SELECTOR_MENUS = '.js-menus';
const SELECTOR_MENU = '.js-menu';
const SELECTOR_MENU_TOGGLE = '.js-menu-toggle';
const SELECTOR_MENU_CONTAINER = '.js-menu-container';
const CLASS_TOGGLED = 'is-toggled';

/**
 * Open an menu, incl. closing adjacent menus.
 */
const open = (menu: Element) => {
  closeAdjacent(menu);
  menu.classList.add(CLASS_TOGGLED);
  const menuToggle = document.querySelector(SELECTOR_MENU_TOGGLE);
  menuToggle.scrollIntoView({
    behavior: 'instant',
  });
  if (menuToggle) {
    menuToggle.setAttribute('aria-expanded', 'true');
  }
};

/**
 * Close an menu.
 */
const close = (menu: Element) => {
  menu.classList.remove(CLASS_TOGGLED);
  const menuToggle = document.querySelector(SELECTOR_MENU_TOGGLE);
  if (menuToggle) {
    menuToggle.setAttribute('aria-expanded', 'false');
  }
};

/**
 * Close menus adjacent to an menu.
 */
const closeAdjacent = (menu: Element) => {
  const menuParent = menu.closest(SELECTOR_MENUS);
  if (!menuParent) {
    return;
  }
  const menuSiblings = menuParent.querySelectorAll(SELECTOR_MENU);
  if (!menuSiblings) {
    return;
  }
  Array.from(menuSiblings).forEach(close);
};

/**
 * Toggle an menu.
 */
const toggle = (menu: Element) => {
  if (menu.classList.contains(CLASS_TOGGLED)) {
    close(menu);
  } else {
    open(menu);
  }
};

/**
 * Initialize an menu, ie. bind event listeners.
 */
const initialize = (menu: Element) => {
  const menuContent = menu.querySelector<HTMLElement>(SELECTOR_MENU_CONTAINER);
  const menuToggle = menu.querySelector<HTMLElement>(SELECTOR_MENU_TOGGLE);

  if (!menuContent || !menuToggle) {
    return;
  }

  const observer = new ResizeObserver(() => {
    menuContent.style.height = `${menuContent.scrollHeight}px`;
  });
  observer.observe(menuContent);

  menuToggle.addEventListener('click', () => toggle(menu));

  addEventListener('hashchange', (event) => {
    if (menu.getAttribute('id') === location.hash.substring(1)) {
      open(menu);
    }
  });
};

Array.from(document.querySelectorAll(SELECTOR_MENU)).forEach((menu) => {
  initialize(menu);
});
